import type { MouseEventHandler, ReactElement, ReactNode } from 'react';

import { SWReactIcons } from '@similarweb/icons';

import { StyledAccountDropdownButton, StyledButtonContent } from './styles';

interface IProps {
  isActive?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
  dataAutomation?: string;
  onClick: MouseEventHandler;
  children: ReactNode;
}

export const AccountDropdownButton = ({
  isDisabled,
  isActive,
  dataAutomation,
  children,
  ...props
}: IProps): ReactElement => {
  return (
    <StyledAccountDropdownButton isActive={isActive} disabled={isDisabled} {...props} data-automation={dataAutomation}>
      <StyledButtonContent>{children}</StyledButtonContent>
      <SWReactIcons iconName={isActive ? 'chev-up' : 'chev-down'} size="xs" />
    </StyledAccountDropdownButton>
  );
};
